export default __webpack_public_path__ + "static/media/img_shop.0f317572.png";